<app-loader *ngIf="isDisabled"></app-loader>
<div class="card">
    <div class="card-header">
        Device Duplicate Recode
    </div>
    <div class="card-body">
        <button type="button" *ngIf="this.common.PageRight.IsPrint" class="btn btn-primary"
            (click)="ESS_DeviceReport()">
            <i class="bi bi-file-earmark-arrow-down" *ngIf="!isDisabled"></i>
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" *ngIf="isDisabled"></span>
            {{!isDisabled?'Excel':'Loading...'}}
        </button>
    </div>
</div>